import styles from '../slides/slides.module.css';
import enhancedStyles from '../CaseBuilderEnhanced.module.css';

/**
 * Side sheet chrome for slide assignment (same pattern as BlockEditorSheet).
 */
export default function SlideAssignmentDrawer({
    open,
    title,
    subtitle = null,
    children,
    footer = null,
    onClose,
}) {
    if (!open) return null;

    return (
        <>
            <div className={styles.sheetOverlay} onClick={onClose} aria-hidden="true" />
            <aside className={styles.sheet} role="dialog" aria-modal="true" aria-label={title}>
                <div className={styles.sheetHeader}>
                    <div>
                        <h3 className={styles.sheetTitle}>{title}</h3>
                        {subtitle ? <p className={styles.sheetSubtitle}>{subtitle}</p> : null}
                    </div>
                    <button type="button" className={enhancedStyles.linkButton} onClick={onClose}>
                        Close
                    </button>
                </div>
                <div className={styles.sheetBody}>{children}</div>
                {footer ? <div className={styles.sheetFooter}>{footer}</div> : null}
            </aside>
        </>
    );
}
